<template>
  <dialog-base
    :visible.sync="visible"
    title="Điều chỉnh tiền đã thu"
    size="md"
    :use-panel="false"
    top="6vh"
    @cancel="handleClose"
  >
    <el-form
      ref="dataForm"
      :model="dataForm"
      :rules="formRules"
      label-width="230px"
      label-position="left"
      class="sk-dialog-content"
    >
      <div class="sk-panel mb-4">
        <div class="sk-panel-head">
          <div class="sk-panel-icon"><i class="el-icon-user" /></div>
          <div>
            <p class="sk-panel-title">Thông tin học sinh</p>
            <p class="sk-panel-subtitle">Điều chỉnh số tiền đã thu của phiếu thu chính thức</p>
          </div>
        </div>

        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="Họ tên" label-width="70px">
              <div class="cmd-readonly">{{ dataForm.fullName || "-" }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Mã học sinh" label-width="100px">
              <div class="cmd-readonly">{{ dataForm.studentCode || "-" }}</div>
            </el-form-item>
          </el-col>
        </el-row>
      </div>

      <div class="sk-panel">
        <div class="sk-panel-head">
          <div class="sk-panel-icon sk-panel-icon--success"><i class="el-icon-money" /></div>
          <div>
            <p class="sk-panel-title">Dữ liệu thanh toán</p>
            <p class="sk-panel-subtitle">Nhập tiền mặt/chuyển khoản, hệ thống tự tính tiền đã thu</p>
          </div>
        </div>

        <el-form-item label="Tiền phải thu">
          <el-currency-input
            v-model="dataForm.sumMoney"
            :options="currencyOptions"
            :disabled="true"
          />
        </el-form-item>

        <el-form-item label="Thiếu/Thừa phiếu thu trước" prop="beforeMoney">
          <el-currency-input
            v-model="dataForm.beforeMoney"
            :options="currencyOptions"
            @input="recalculate"
          />
        </el-form-item>

        <el-form-item label="Tiền mặt" prop="cashMoney">
          <el-currency-input
            v-model="dataForm.cashMoney"
            :options="currencyOptions"
            @input="recalculate"
          />
        </el-form-item>

        <el-form-item label="Chuyển khoản" prop="transferMoney">
          <el-currency-input
            v-model="dataForm.transferMoney"
            :options="currencyOptions"
            @input="recalculate"
          />
        </el-form-item>

        <el-form-item label="Tiền đã thu">
          <el-currency-input
            v-model="dataForm.collectedMoney"
            :options="currencyOptions"
            :disabled="true"
          />
        </el-form-item>

        <el-form-item :label="dataForm.afterMoney < 0 ? 'Số tiền còn thiếu' : 'Số tiền còn thừa'">
          <el-currency-input
            :value="afterMoneyAbs"
            :options="currencyOptions"
            :disabled="true"
          />
        </el-form-item>

        <el-form-item label="Xử lý thiếu/thừa">
          <el-radio-group v-model="dataForm.transactionEntry">
            <el-radio label="MONEY_WALLET">Không chuyển</el-radio>
            <el-radio label="MONEY_MONTH">Sang tháng sau</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="Ghi chú">
          <el-input
            v-model="dataForm.note"
            type="textarea"
            :rows="3"
            placeholder="Nhập ghi chú (nếu có)"
            maxlength="500"
            show-word-limit
          />
        </el-form-item>
      </div>
    </el-form>

    <template #footer>
      <div class="sk-dialog__footer">
        <el-button class="btn-cancel" type="danger" plain @click="handleClose">Hủy</el-button>
        <el-button class="btn-save" type="primary" :loading="loading" @click="handleSubmit" v-if="checkPermission(['tuition_payment_v4'])">Lưu</el-button>
      </div>
    </template>
  </dialog-base>
</template>

<script>
import DialogBase from "@/components/DialogBase.vue";
import ManagingStudentInvoiceService from "@/services/tutition_v3/ManagingStudentInvoiceService";
import NotifyMessage from "@/commonFuncion/NotifyMessage";
import checkPermission from "@/utils/permission";

function initDataForm() {
  return {
    idx: "",
    fullName: "",
    studentCode: "",
    sumMoney: 0,
    beforeMoney: 0,
    cashMoney: 0,
    transferMoney: 0,
    collectedMoney: 0,
    afterMoney: 0,
    transactionEntry: "MONEY_WALLET",
    note: "",
  };
}

export default {
  name: "AdjustCollectedMoneyDialog",
  components: { DialogBase },
  data() {
    const numberValidator = (fieldLabel) => (rule, value, callback) => {
      const num = Number(value);
      if (value === null || value === undefined || Number.isNaN(num)) {
        callback(new Error(`${fieldLabel} không hợp lệ`));
        return;
      }
      callback();
    };

    return {
      visible: false,
      loading: false,
      currencyOptions: {
        currency: "VND",
        locale: "vi",
        precision: 0,
        allowNegative: true,
      },
      dataForm: initDataForm(),
      formRules: {
        beforeMoney: [{ validator: numberValidator("Thiếu/Thừa phiếu thu trước"), trigger: "blur" }],
        cashMoney: [{ validator: numberValidator("Tiền mặt"), trigger: "blur" }],
        transferMoney: [{ validator: numberValidator("Chuyển khoản"), trigger: "blur" }],
      },
    };
  },
  computed: {
    afterMoneyAbs() {
      return Math.abs(Number(this.dataForm.afterMoney) || 0);
    },
  },
  methods: {
    checkPermission,
    open(row) {
      this.dataForm = {
        idx: row.idx || "",
        fullName: row.fullName || "",
        studentCode: row.studentCode || "",
        sumMoney: Number(row.sumMoney) || 0,
        beforeMoney: Number(row.beforeMoney) || 0,
        cashMoney: Number(row.cashMoney) || 0,
        transferMoney: Number(row.transferMoney) || 0,
        collectedMoney: Number(row.collectedMoney) || 0,
        afterMoney: Number(row.afterMoney) || 0,
        transactionEntry: row.transactionEntry || "MONEY_WALLET",
        note: row.note || "",
      };
      this.recalculate();
      this.visible = true;
      this.$nextTick(() => this.$refs.dataForm?.clearValidate());
      console.log(this.dataForm)
    },

    recalculate() {
      const cash = Number(this.dataForm.cashMoney) || 0;
      const transfer = Number(this.dataForm.transferMoney) || 0;
      const sumMoney = Number(this.dataForm.sumMoney) || 0;
      const beforeMoney = Number(this.dataForm.beforeMoney) || 0;

      this.dataForm.collectedMoney = cash + transfer;
      this.dataForm.afterMoney = this.dataForm.collectedMoney - sumMoney + beforeMoney;
    },

    handleSubmit() {
      this.$refs.dataForm.validate(async (valid) => {
        if (!valid) return;
        this.loading = true;
        try {
          const payload = {
            idx: this.dataForm.idx,
            sumMoney: this.dataForm.sumMoney,
            beforeMoney: this.dataForm.beforeMoney,
            cashMoney: this.dataForm.cashMoney,
            transferMoney: this.dataForm.transferMoney,
            collectedMoney: this.dataForm.collectedMoney,
            afterMoney: this.dataForm.afterMoney,
            transactionEntry: this.dataForm.transactionEntry,
            note: this.dataForm.note,
          };
          const response = await ManagingStudentInvoiceService.adjustPayment(payload);
          if (response?.data?.data === true || response?.data?.status === 200) {
            NotifyMessage.leftCornerNotificationSuccess("Điều chỉnh tiền đã thu thành công.");
            this.$emit("saved");
            this.handleClose();
          } else {
            throw new Error("Điều chỉnh thất bại.");
          }
        } catch (error) {
          console.error(error);
          NotifyMessage.leftCornerNotificationError(
            (error && error.response && error.response.data && error.response.data.message) ||
              "Điều chỉnh tiền đã thu thất bại."
          );
        } finally {
          this.loading = false;
        }
      });
    },

    handleClose() {
      this.visible = false;
      this.loading = false;
      this.$refs.dataForm?.resetFields();
      this.dataForm = initDataForm();
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/style/sk-dialog";

.cmd-readonly {
  padding: 7px 11px;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  font-weight: 600;
  color: #1e293b;
}
</style>
